const oidcDevConfig = {
  client_id: 'Site2Lab_XXPA_Preprod',
  redirect_uri: window.location.origin + '/authentication/callback',
  silent_redirect_uri: window.location.origin + '/authentication/silent-callback',
  scope: 'openid profile email',
  authority: 'https://uat.id.eurofins.com',
  service_worker_only: true,
  grant_type: 'authorization code',
  post_logout_redirect_uri: 'query',
  userinfo_endpoint: 'https://uat.id.eurofins.com/idp/userinfo.openid',
  token_endpoint: 'https://uat.id.eurofins.com/as/token.oauth2',
  authorization_endpoint: 'https://uat.id.eurofins.com/as/authorization.oauth2',
  revocation_endpoint: 'https://uat.id.eurofins.com/as/revoke_token.oauth2'
};

export default oidcDevConfig;